import "./ResumePage.css";
import resumeImg from "../assets/img/resume.png";

export const ResumePage = () => {
  return (
    <div className="resume-page">
      <div className="resume-container">
        <a href="/Billy_Chiu_Resume.pdf" target="_blank" rel="noopener noreferrer">
          <img src={resumeImg} alt="Billy Chiu Resume" className="resume-image" />
        </a>
      </div>
    </div>
  );
};
